import React, { useState } from 'react';
import { useMutation } from '@apollo/client/react';
import { NotAReseller as SharedNotAReseller } from '@gastrosoft/shared/auth';
import { useOrganization } from '@/app/contexts/OrganizationContext';
import { useNotification } from '@/app/contexts/NotificationContext';
import { SendMailDocument } from '@/generated/pos-types';

export default function NotAReseller() {
  const { currentTenantId } = useOrganization();
  const { showSuccess, showError } = useNotification();
  const [sendMail] = useMutation(SendMailDocument);

  return (
    <SharedNotAReseller
      currentTenantId={currentTenantId}
      onSendMail={async (input) => {
        const res = await sendMail({
          variables: { sendMail: input },
          context: { schema: 'PosSchema' },
        });
        return {
          isSuccess: Boolean(res.data?.sendMail?.isSuccess),
          message: res.data?.sendMail?.message,
        };
      }}
      onSuccess={showSuccess}
      onError={showError}
    />
  );
}
